import React from 'react';
import {
  Dialog,
  Box,
  IconButton,
  useMediaQuery,
  Theme,
  Typography,
  Button,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';

interface Itinerary {
  일정번호: number;
  일정명: string;
  내용?: string;
  엑셀파일경로?: string;
}

interface ItineraryDialogProps {
  open: boolean;
  onClose: () => void;
  itinerary: Itinerary | null;
}

const ItineraryDialog: React.FC<ItineraryDialogProps> = ({
  open,
  onClose,
  itinerary,
}) => {
  const isSmallScreen = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  if (!itinerary) return null;

  const handleDownload = () => {
    if (itinerary.엑셀파일경로) {
      window.open(itinerary.엑셀파일경로, '_blank');
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="lg"
      fullScreen={isSmallScreen}
      sx={{
        '& .MuiDialog-paper': {
          margin: { xs: 0, sm: 2 },
          maxHeight: '100vh',
          borderRadius: { xs: 0, sm: 1 },
        },
      }}>
      <Box sx={{ height: '95vh', position: 'relative', overflow: 'hidden' }}>
        <Box
          sx={{
            position: 'absolute',
            left: 24,
            right: 24,
            top: 16,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            zIndex: 1,
            height: '48px'
          }}>
          <Box sx={{ 
            display: 'flex', 
            margin: '0 auto', 
            gap: { xs: 2, sm: 4 },
            flex: 1,
            minWidth: 0
          }}>
            <Typography 
              sx={{ 
                fontSize: { xs: '14px', sm: '20px' }, 
                fontWeight: 700,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                flex: 1
              }}>
              {itinerary.일정명}
            </Typography>
            {itinerary.엑셀파일경로 && itinerary.엑셀파일경로 !== '' && (
              <Button
                variant="contained"
                startIcon={isSmallScreen ? undefined : <DownloadIcon />}
                onClick={handleDownload}
                size="small"
                sx={{
                  bgcolor: 'primary.main',
                  color: 'white',
                  '&:hover': {
                    bgcolor: 'primary.dark',
                  },
                  textTransform: 'none',
                  fontWeight: 500,
                  fontSize: '14px',
                  height: '32px',
                  minWidth: { xs: '32px', sm: 'auto' },
                  padding: { xs: '8px', sm: '6px 16px' }
                }}>
                {isSmallScreen ? <DownloadIcon /> : '일정 다운로드'}
              </Button>
            )}
          </Box>
          <IconButton
            onClick={onClose}
            sx={{
              color: 'grey.700',
              bgcolor: 'white',
              '&:hover': {
                bgcolor: 'grey.100',
              },
              ml: 1
            }}>
            <CloseIcon />
          </IconButton>
        </Box>
        <iframe
          srcDoc={
            itinerary?.내용
              ? `
              <style>
                  .download-button {
                    pointerEvents: none !important;
                    backgroundColor: #ccc !important; 
                  }
              </style>
              ${itinerary.내용}
            `
              : ''
          }
          style={{
            width: '100%',
            height: 'calc(95vh - 64px)',
            marginTop: '56px',
            border: 'none',
          }}
          title="일정 내용"
        />
      </Box>
    </Dialog>
  );
};

export default ItineraryDialog;